import dayjs from "dayjs";

export const isToday = (date: Date) => dayjs(date).isSame(dayjs(), "day");
export const isYesterday = (date: Date) =>
  dayjs(date).isSame(dayjs().subtract(1, "day"), "day");
